import { useTranslations } from 'next-intl';
import { useStoreMap } from 'effector-react';
import classNames from 'classnames';
import { getSortedDashboardFileIds } from '@nx-frontend/shared/store/feature-files';
import { getBorderClassNames, getTextClassNames } from '@nx-frontend/shared/themes';
import {
  BorderPosition,
  PortalBorderType,
  PortalStyleConfig,
  PortalTextType,
  ThemeColorSchemas,
} from '@nx-frontend/shared/types';
import { FileListItem, FileListItemColumn } from '../file-list-item';
import { FileManagerHandlers } from '../model';
import { EmptyState } from './files-manager-empty-state';

export interface FileManagerListProps {
  themeColors: ThemeColorSchemas;
  themeStyle: PortalStyleConfig;
  orgRole: string;
  userId: number;
  fileOpenHost: string;
  canEditOtherUsersFile?: boolean;
  canCreateEsign: boolean;
  canSubmitEsign: boolean;
  isCustomizerMode?: boolean;
  handlers?: FileManagerHandlers;
  allowedTargets?: string[];
  personalizationUserId?: number | null;
}
export function FilesManagerList({
  themeColors,
  themeStyle,
  orgRole,
  userId,
  fileOpenHost,
  canEditOtherUsersFile,
  canCreateEsign,
  canSubmitEsign,
  isCustomizerMode,
  handlers,
  allowedTargets,
  personalizationUserId,
}: FileManagerListProps) {
  const fileIds = useStoreMap(getSortedDashboardFileIds(allowedTargets));
  const t = useTranslations('files_dashboard');
  return (
    <div>
      <div>
        <div
          className={classNames(
            'flex justify-between px-0.5 sm:px-4 text-[10px] leading-4 uppercase border-b overflow-x-auto',
            ...getTextClassNames(themeColors, PortalTextType.SURFACE),
            ...getBorderClassNames(themeColors, themeStyle, PortalBorderType.SURFACE, {
              position: BorderPosition.BOTTOM,
            })
          )}
        >
          <div className="w-[64%] sm:w-[35%] py-2">{t('files_dashboard-name')}</div>
          {/* <div className="w-[13%] py-1">Format</div> */}
          {(canCreateEsign || canSubmitEsign) && (
            <div className={`py-2 w-[52%] sm:w-[18%]`}>{t('files_dashboard-esign')}</div>
          )}
          <div className="w-[21%] py-2 hidden sm:block">{t('files_dashboard-owner')}</div>
          <div className="w-[15%] py-2 hidden sm:block">{t('files_dashboard-size')}</div>
          <div className={`w-[30%] sm:w-[10%] py-2 ${canCreateEsign || canSubmitEsign ? 'hidden lg:block' : ''} `}>
            {t('files_dashboard-created')}
          </div>
          <div className="w-[6%] py-2 hidden sm:block"></div>
        </div>
      </div>

      <div className="py-2 flex-1 overflow-x-visible">
        {fileIds.length ? (
          fileIds.map((id, index, array) => {
            const isLastItem = index === array.length - 1;
            return (
              <FileListItem
                key={id}
                id={id}
                themeColors={themeColors}
                themeStyle={themeStyle}
                hasBorder={!isLastItem}
                userId={userId}
                orgRole={orgRole}
                fileOpenHost={fileOpenHost}
                personalizationUserId={personalizationUserId}
                visibleColumns={[
                  FileListItemColumn.NAME,
                  FileListItemColumn.ESIGN,
                  FileListItemColumn.USER,
                  FileListItemColumn.SIZE,
                  FileListItemColumn.CREATED,
                  FileListItemColumn.MENU,
                ]}
                columnWidths={
                  {
                    // name: '35%',
                    // user: '29%',
                    // size: '15%',
                    // created: '15%',
                    // menu: '6%',
                  }
                }
                canEditOtherUsersFile={canEditOtherUsersFile}
                canCreateEsign={canCreateEsign}
                canSubmitEsign={canSubmitEsign}
                isCustomizerMode={isCustomizerMode}
                handlers={handlers}
              />
            );
          })
        ) : (
          <EmptyState themeColors={themeColors} />
        )}
      </div>
    </div>
  );
}

export default FilesManagerList;
